import SubClientListItem from '../SubClientListItem/SubClientListItem'
import './SubClientList.css'

export default function SubClientList({user, client, subClients, updateSubClients, toggleNotifications}) {
  return (
    <div className='SubClientList'>
        {subClients.map((subClient) => (
            <SubClientListItem key={subClient._id} user={user} client={client} subClient={subClient} updateSubClients={updateSubClients} toggleNotifications={toggleNotifications} />
        ))}
    </div>
  )
}
